module.exports = __webpack_public_path__ + "media/touchdown_left_2.e3009ad2.mp4";